import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import Enum from '@square/dashboard-utilities/utils/enum';
const Format = new Enum(['JOSE_JWE']);
const EncryptedKeyedCard = ProtoBaseModel.extend({
  format: attr(Format, {
    defaultValue: Format.JOSE_JWE
  }),
  // ciphertext is actually a byte field which will need to be base64 encoded to be sent across service container
  ciphertext: attr(String),
  ciphertextString: attr(String)
});
export default ProtoBaseModel.extend({
  keyedCard: attr(EncryptedKeyedCard)
}).reopenClass({
  createFromCiphertext(ciphertextString) {
    return this.create({
      keyedCard: EncryptedKeyedCard.create({
        ciphertextString
      })
    });
  }
});